<div class="rp-bg" (click)="close.emit()">
  <div class="rp" (click)="$event.stopPropagation()" role="dialog" aria-label="Hivatkozás csatolása">
    <header class="rp__head">
      <b>Csatolás a beszélgetéshez</b>
      <button type="button" class="rp__x" (click)="close.emit()" aria-label="Bezárás">✕</button>
    </header>

    <div class="rp__empty" *ngIf="!tabs.length">Nincs jogosultságod rendelést, taskot vagy levelezést csatolni.</div>

    <ng-container *ngIf="tab">
      <div class="rp__tabs">
        <button type="button" *ngFor="let t of tabs" [class.on]="t === tab" (click)="setTab(t)">{{ t.label }}</button>
      </div>
      <div class="rp__search">
        <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="6.5"></circle><line x1="16" y1="16" x2="20.5" y2="20.5"></line></svg>
        <input #search type="search" [(ngModel)]="q" (ngModelChange)="onQuery()" [placeholder]="tab.placeholder" autocomplete="off">
      </div>

      <div class="rp__list">
        <div class="rp__hint" *ngIf="!q && results.length">Legutóbbiak</div>
        <button type="button" class="rp__item" *ngFor="let r of results" [attr.data-type]="r.type" (click)="pick.emit(r)">
          <span class="rp__title">{{ r.title }}</span>
          <span class="rp__sub" *ngIf="r.subtitle">{{ r.subtitle }}</span>
          <span class="rp__meta"><i *ngIf="r.status">{{ r.status }}</i>{{ r.meta }}</span>
        </button>
        <div class="rp__empty" *ngIf="!loading && !results.length && !error">Nincs találat.</div>
        <div class="rp__empty rp__empty--err" *ngIf="error">{{ error }}</div>
        <div class="rp__empty" *ngIf="loading && !results.length">Keresés…</div>
      </div>
    </ng-container>
  </div>
</div>
